import { render, staticRenderFns } from "./BsListNavItem.vue?vue&type=template&id=297cd8d1&"
import script from "./BsListNavItem.vue?vue&type=script&lang=js&"
export * from "./BsListNavItem.vue?vue&type=script&lang=js&"
import style0 from "./BsListNavItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports